import { useState } from 'react'
import { Input } from './input'
import { Popover } from './popover'

interface TimePickerProps {
  id?: string
  value: string // HH:mm
  onChange: (value: string) => void
  required?: boolean
}

/** 常用时间段（08:00 - 22:00，每小时） */
const SLOTS = Array.from({ length: 15 }, (_, i) => {
  const h = i + 8
  return `${String(h).padStart(2, '0')}:00`
})

/** 时间选择器：点击 Input 弹出每小时时间格，同时保留手动输入 */
export function TimePicker({ id, value, onChange, required }: TimePickerProps) {
  const [open, setOpen] = useState(false)

  return (
    <div className="relative">
      <Input
        id={id}
        type="time"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onClick={() => setOpen(true)}
        onFocus={() => setOpen(true)}
        required={required}
      />
      <Popover open={open} onClose={() => setOpen(false)} align="right">
        <div className="grid grid-cols-4 gap-0.5 p-2 min-w-[192px]" data-testid={`timepicker-popover${id ? `-${id}` : ''}`}>
          {SLOTS.map((slot) => (
            <button
              key={slot}
              type="button"
              className={`text-xs rounded px-1 py-1.5 hover:bg-slate-100 ${value === slot ? 'bg-slate-900 text-white hover:bg-slate-800' : ''}`}
              onMouseDown={(e) => {
                e.preventDefault()
                onChange(slot)
                setOpen(false)
              }}
            >
              {slot}
            </button>
          ))}
        </div>
      </Popover>
    </div>
  )
}
